<template>
  <div>
    <div
      class="mt-3 mb-4 field-of-fields"
      style="width: 75%; display: block; margin-left: auto; margin-right: auto;"
    >
      <div v-if="$store.getters.userID">
        <h3 style="">Family Information</h3>
        <hr />
        <p class="text-require-notice">Fields marked with an * are required</p>
        <FormGroupRowLayout
          :listFields="$store.getters.familyInformationListFields"
          :modelData="user"
          :submitClicked="submitClicked"
        >
          <template slot="children">
            <ApplicationSectionWithDialog
              sectionTitle="Children"
              name="Children"
              :data="user.children"
              :listFields="listChildrenFields"
              :keyTitles="['first_name', 'last_name']"
            />
          </template>
        </FormGroupRowLayout>
        <div class="submit-button-section">
          <button
            class="mylisting-button dark-button"
            @click="submitApplication()"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FormGroupRowLayout from "../../common/FormGroupRowLayout";
import { ACTION_TYPE } from "../../../constants/custom-define-type";
import DetailSectionRowLayout from "../../common/DetailSectionRowLayout";
import ApplicationSectionWithDialog from "../../common/ApplicationSectionWithDialog";
import { SERVICE_TYPE } from "../../../constants/employer";

export default {
  props: ["user"],
  components: {
    FormGroupRowLayout,
    DetailSectionRowLayout,
    ApplicationSectionWithDialog
  },
  data() {
    return {
      listOriginalChild: JSON.parse(JSON.stringify(this.user.children)),
      submitClicked: false,
      numberRequestOfChildrenApi: 0,
      numberResponseOfChildrenApi: 0
    };
  },
  computed: {
    listChildrenFields() {
      return this.getListChildrenFields();
    },
    serviceType() {
      return this.user.selector1;
    }
  },
  watch: {
    serviceType(value) {
      // Find all field which corresponding with new service type
      const listModelOfServiceType = this.getListFieldModelForOption(
        this.$store.getters.familyInformationListFields,
        value
      ).map(field => field.model);
      // Get all model of family field list
      const listAllModel = this.$store.getters.familyInformationListFields
        .filter(field => field.model != null)
        .map(field => field.model);
      const listUnusedKey = listAllModel.filter(
        model => !listModelOfServiceType.includes(model)
      );
      // Keep the common data between old service type and new service type,
      // Remove other information
      listUnusedKey.forEach(key => delete this.user[key]);
    }
  },
  methods: {
    getListChildrenFields() {
      if (this.user.selector1 === SERVICE_TYPE.NEW_BORN) {
        return this.$store.getters.childrenListFieldsNewBorn;
      } else if (this.user.selector1 === SERVICE_TYPE.SITTER) {
        return this.$store.getters.childrenListFieldsSitter;
      } else if (this.user.selector1 === SERVICE_TYPE.NANNY) {
        return this.$store.getters.childrenListFieldsNanny;
      } else if (this.user.selector1 === SERVICE_TYPE.PRIVATE_EDUCATOR) {
        return this.$store.getters.childrenListFieldsPrivateEducator;
      }
    },
    checkInvalidFields() {
      if (
        this.hasInvalidField(
          this.user,
          this.$store.getters.familyInformationListFields
        )
      ) {
        return true;
      }
      return false;
    },
    submitApplication() {
      this.submitClicked = true;
      if (this.checkInvalidFields()) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
      } else {
        this.updateFamilyFormInfo();
      }
    },
    async updateFamilyFormInfo() {
      const res = await axios.patch(
        // "/api/people/" + this.$store.getters.userID.toString() + "/",
        "/api/people/" + this.user.id.toString() + "/",
        this.extractSelectedFields(
          this.user,
          this.$store.getters.familyInformationListFields
        )
      );
      if (!res) {
        return;
      }
      const listCurrentChildId = this.user.children.map(child => child.id);
      this.listRemovedChild = this.listOriginalChild.filter(
        child => !listCurrentChildId.includes(child.id)
      );
      this.numberRequestOfChildrenApi =
        this.listRemovedChild.length + this.user.children.length;
      for (const child of this.listRemovedChild) {
        this.deleteChild(child.id);
      }
      for (const child of this.user.children) {
        if (child.id) {
          const originalChild = this.listOriginalChild.find(
            oriChild => oriChild.id === child.id
          );
          if (
            this.isUnchangedObject(
              originalChild,
              child,
              this.getListChildrenFields()
            )
          ) {
            this.numberRequestOfChildrenApi -= 1;
          } else {
            this.updateChild(child);
          }
        } else {
          this.addChild(child);
        }
      }
      this.handleFinishSubmitChildrenInfo();
    },
    async addChild(child) {
      await axios.post("/api/children/", {
        user: this.$store.getters.userID,
        type: "Child",
        ...child,
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName
      });
      this.numberResponseOfChildrenApi += 1;
      this.handleFinishSubmitChildrenInfo();
    },
    async deleteChild(childId) {
      await axios.delete(`/api/children/${childId}`);
      this.numberResponseOfChildrenApi += 1;
      this.handleFinishSubmitChildrenInfo();
    },
    async updateChild(child) {
      await axios.patch(
        `/api/children/${child.id}`,
        this.extractSelectedFields(child, this.getListChildrenFields())
      );
      this.numberResponseOfChildrenApi += 1;
      this.handleFinishSubmitChildrenInfo();
    },
    handleFinishSubmitChildrenInfo() {
      if (
        this.numberRequestOfChildrenApi === this.numberResponseOfChildrenApi
      ) {
        this.$emit("infoSaved");
      }
    }
  }
};
</script>

<style>
.submit-button-section {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.text-require-notice {
  font-size: 0.8rem;
  color: var(--coredarkcolor);
}
</style>



// WEBPACK FOOTER //
// src/components/employers/applications/FamilyFormEdit.vue